import ServiceDetailPage from '../components/services/ServiceDetailPage';
import { getServicePageConfig } from '../data/services/servicesRegistry';

const LogisticsSupportService = () => (
  <ServiceDetailPage {...getServicePageConfig('logisticsSupport')} />
);

export default LogisticsSupportService;
